module.exports = __webpack_public_path__ + "static/04-1-4cbcf67eaf5f2635ce5b1b2d92688de5.jpg";